import axios from 'axios';
import router from '@/router/router';

// import eventBus from '@/event-bus/eventBus';
// import event from '@/event-bus/event';

// 'X-Requested-With' for back-end to identify API
const http = axios.create({
	baseURL: process.env.BASE_URL,
	timeout: 60000,
	headers: {
		'X-Requested-With': 'XMLHttpRequest',
		common: {
			Accept: 'application/json;charset=utf-8',
			token: null,
		},
	},
	withCredentials: true,
	responseEncoding: 'utf8',
});

function SeverErrorSwitch(level, msgCode) {
	let result = null;
	switch (level) {
		case 'error':
			// error toast
			// eventBus.$emit(event.noticeError, msgCode);
			break;
		case 'self':
			// form error
			result = {
				error: true,
				errorCode: msgCode,
			};
			break;
		case 'alarm':
			// eventBus.$emit(event.alarmBox, msgCode);
			break;

			// no default
	}
	return result;
}

http.interceptors.response.use((response) => {
	if (response.data.message != null) {

		//  彈出成功info toaster
		// eventBus.$emit(event.noticeInfo, response.data.message.msgCode);
	}
	return response.data.result;
}, (error) => {
	let result = null;
	// alert(error)
	if (error.response === undefined) {
		// eventBus.$emit(event.noticeError, 'NetWork Error');
		return result;
	}
	switch (error.response.status) {
		case 500:
			console.log('error=', error);
			var msg = error.response.data.message.msg;
			var level = error.response.data.message.level;
			var title = error.response.data.message.title;
			var returnName = error.response.data.message.returnName;
			// 	result = SeverErrorSwitch(msg.level, msg.msgCode);
			// 	return result;
			// }
			// if(msgCode === process.env.SMSPAY_EXCEPTION_CODE){
			// 	router.push({ name: 'sms-pay-msg', params: { msg: msg, code: msgCode } });
			// } else {
			if (level === 'warn') {
				if (returnName == null) {
					router.push({ name: 'gt-warn', params: { msg: msg, returnUrl: process.env.PRE_PAGE_CODE,
						title: title } });
				} else {
					router.push({ name: 'gt-warn', params: { msg: msg, title: title,
						returnName: returnName } });
				}
			} else {
				if (returnName) {
					router.push({ name: 'gt-error', params: { msg: msg, returnUrl: process.env.PRE_PAGE_CODE, returnName: returnName } });
				} else {
					router.push({ name: 'gt-error', params: { msg: msg, returnUrl: process.env.PRE_PAGE_CODE } });
				}
				
			}
			break;
		case 404:

			break;
		case 403:
			var msg = "很抱歉！您登入的身份不適用此功能。";
			router.push({ name: 'gt-error', params: { msg: msg } });
			break;
		case 401:
			// window.location.href = 'http://1.34.159.71:8080/cas/login?service=http://127.0.0.1:8080/MCP/mcp/serviceApply';
			if (error.response.data.redirect == false) {
				// nothing
				result = error.response.data;
			} else {
				window.location.href = error.response.data.loginUrl;
			}
			break;
		default:
			return result;
	}
	return result;
});

export default http;



// WEBPACK FOOTER //
// ./src/util/http.js